import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiButton = (_param)=>{
    var { biData, innerRef, stopPropagation, disabled } = _param, props = _object_without_properties(_param, [
        "biData",
        "innerRef",
        "stopPropagation",
        "disabled"
    ]);
    const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
    return /*#__PURE__*/ React.createElement("button", _object_spread_props(_object_spread({
        /*
        Some screen readers don't pick up that a button is disabled
        when only `disable` is set, so use aria-disabled as well
      */ disabled: disabled,
        "aria-disabled": disabled
    }, props), {
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
        }
    }));
};
BiButton.displayName = 'BiButton';
export default BiButton;
